import gql from 'graphql-tag';

export interface KindbodyDocument {
  id: string;
  patientId: string;
  pdfResults: string;
  updatedAt: string;
  htmlResults: string;
  createdAt: string;
  chReportId: string;
}

export interface KindbodyDocumentsResponse {
  kindbodyDocs: KindbodyDocument[];
}

export const kindbodyDocumentsQuery = gql`
  query kindbodyDocuments {
    labOrderReports {
      id
      patientId
      chReportId
      createdAt
      updatedAt
      pdfResults
      htmlResults
    }
  }
`;
